import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteMaintenanceTypeSaga,
  getMaintenanceTypeDetailsSaga,
  getMaintenanceTypeListSaga,
} from "src/store/maintenance-types/saga";
import {
  MaintenanceTypeDetailDto,
  MaintenanceTypeDto,
} from "src/store/maintenance-types/type";
import MaintenanceTypeCreateForm from "./create";
import MaintenanceTypeEditForm from "./edit";
const MaintenanceTypePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<MaintenanceTypeDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<MaintenanceTypeDetailDto>();
  const columns = [
    {
      text: t("MaintenanceType.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("MaintenanceType.PageTitle")}
        metaTag={t("MaintenanceType.MetaTag")}
        gridProps={{
          addTitle: t("MaintenanceType.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getMaintenanceTypeListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getMaintenanceTypeDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: MaintenanceTypeDto) =>
              t("MaintenanceType.DeleteQA", {
                name: data.Name,
              }),
            action: deleteMaintenanceTypeSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <MaintenanceTypeCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getMaintenanceTypeListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <MaintenanceTypeEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getMaintenanceTypeListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default MaintenanceTypePage;
